export enum CanonicalProductIdentifiersDomain {
  GTIN = 'gtin',
  VAT = 'vat',
  SENDER_INTERNAL = 'sender_internal',
  RECEIVER_INTERNAL = 'receiver_internal',
}

export enum CanonicalPartyIdentifiersDomain {
  gln = 'gln',
  vat = 'vat',
  receiver_internal = 'receiver_internal',
}

export type CanonicalPostalAddress = {
  street: string | null;
  city: string | null;
  state: string | null;
  postal_code: string | null;
  country_code: string | null;
};

export type CanonicalParty = {
  name: string | undefined;
  identifiers: Record<CanonicalPartyIdentifiersDomain, string | null>;
  postal_address: CanonicalPostalAddress;
  contacts?: {
    main: {
      first_name: string | undefined;
      email: string | undefined;
    };
  };
};

export type CanonicalLineItem = {
  order_line_identifier: string;
  item: {
    type: 'PRODUCT';
    identifiers: Record<string, string>;
    name: string | null;
    unit_of_measure: string | null | undefined;
    tax_percentage: number | null | undefined;
    unit_price: number | null | undefined;
  };
  modification_groups?:
    | Array<{
        allowances: Array<{
          type: 'RELATIVE' | 'ABSOLUTE';
          amount: number | null | undefined;
          percentage: number | null | undefined;
        }>;
      }>
    | undefined;
  ordered_quantity: number;
};

export type Canonical = {
  order_identifier: string;
  order_date: number;
  currency: string | null | undefined;
  parties: {
    buyer: CanonicalParty;
    supplier: CanonicalParty;
    ship_to: CanonicalParty;
  };
  line_items: Array<CanonicalLineItem>;
  comments: string | undefined;
};
